jQuery(document).ready(function($) {


    // Helper function to load safeguards for a project
    function loadSafeguardsForProject(project, evidenceId, $tableContainer) {
        console.log('loadSafeguardsForProject: Started for project:', project, 'evidenceId:', evidenceId);
        
        // Clean up any existing DataTables in this container first
        $tableContainer.find('table.safeguards-table-card').each(function() {
            if ($.fn.DataTable.isDataTable(this)) {
                $(this).DataTable().destroy();
            }
        });
        
        $tableContainer.html('<div class="loader-sm"></div>'); // Show a loader
        
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'get_project_safeguards',
                projects: [project],
                evidence_id: evidenceId,
                nonce: evidenceData.nonce
            },
            success: function(safeguardsResponse) {
                console.log('loadSafeguardsForProject: AJAX success for project:', project, 'Response:', safeguardsResponse);
                if (safeguardsResponse.success && safeguardsResponse.data) {
                    const safeguards = safeguardsResponse.data;
                    console.log('loadSafeguardsForProject: Safeguards data:', safeguards);

                    if (safeguards.length === 0) {
                        $tableContainer.html('<p class="text-muted">No safeguards found for this project.</p>');
                        console.log('loadSafeguardsForProject: No safeguards returned for project:', project);
                        return;
                    }

                    const tableId = 'safeguards-table-' + project.replace(/[^a-zA-Z0-9]/g, '_') + '-' + new Date().getTime();
                    const table = $(`<table id="${tableId}" class="table table-bordered table-sm safeguards-table-card" style="width:100%"><thead><tr><th class="safeguard-select-header" style="width: 10%; text-align: center;">Select</th><th class="safeguard-id-header" style="width: 15%; text-align: center;">ID</th><th class="safeguard-description-header">Description</th></tr></thead><tbody></tbody></table>`);
                    const tbody = table.find('tbody');

                    safeguards.forEach(function(safeguard) {
                        const row = $('<tr></tr>');
                        const checkboxCell = $('<td class="text-center safeguard-select"><input type="checkbox" class="safeguard-checkbox"></td>');
                        checkboxCell.find('.safeguard-checkbox').prop('checked', safeguard.selected).data('safeguard-id', safeguard.id);
                        row.append(checkboxCell);
                        row.append(`<td class="safeguard-id">${safeguard.id}</td>`);
                        row.append(`<td class="safeguard-description">${safeguard.description}</td>`);
                        tbody.append(row);
                    });

                    $tableContainer.empty().append(table);
                    const dataTable = $('#' + tableId).DataTable({
                        "lengthChange": false,
                        "pageLength": 10,
                        "dom": "f" +
                               "<'row'<'col-sm-12'tr>>" +
                               "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
                        "order": [[1, "asc"]], // Sort by safeguard ID column (index 1) ascending
                        "columnDefs": [
                            { 
                                "orderable": false, 
                                "targets": 0,
                                "width": "10%"
                            }, // Disable sorting on checkbox column
                            { 
                                "targets": 1,
                                "type": "string",
                                "width": "20%",
                                "render": function(data, type, row) {
                                    if (type === 'sort') {
                                        // Pad numbers for proper alphanumeric sorting
                                        return data.replace(/(\d+)/g, function(match) {
                                            return match.padStart(10, '0');
                                        });
                                    }
                                    return data;
                                }
                            },
                            {
                                "targets": 2,
                                "width": "40%"
                            },
                            { 
                                "orderable": false, 
                                "targets": 3,
                                "width": "30%"
                            } // Disable sorting on user assignment column
                        ],
                        "language": {
                            "paginate": {
                                "previous": "‹",
                                "next": "›"
                            }
                        },
                        "initComplete": function() {
                            const searchInput = $(`#${tableId}_filter input`);
                            const searchWrapper = $(`#${tableId}_filter`);
                            
                            // Only look for search container within the same card (for new project cards)
                            const $cardBody = $tableContainer.closest('.card-body');
                            let searchContainer = null;
                            
                            if ($cardBody.length > 0) {
                                // This is a new project card - find its specific search container
                                searchContainer = $cardBody.find('.safeguard-search-container');
                            }
                            
                            if (searchContainer && searchContainer.length > 0) {
                                // Clear any existing search inputs in this specific container first
                                searchContainer.find('input[type="search"]').remove();
                                
                                searchInput.attr('placeholder', 'Search safeguards...');
                                searchInput.unwrap(); // Remove the label
                                searchContainer.append(searchInput);
                                searchWrapper.remove(); // Remove the empty div
                            } else {
                                console.warn('Search container not found for table:', tableId);
                                // Keep the search in its default location if container not found
                            }
                        }
                    });
                    console.log('loadSafeguardsForProject: Table populated and initialized for project:', project);
                } else {
                    $tableContainer.html('<p class="text-danger">Error loading safeguards.</p>');
                    console.error('loadSafeguardsForProject: AJAX call was not successful. Response:', safeguardsResponse);
                }
            },
            error: function(xhr, status, error) {
                $tableContainer.html('<p class="text-danger">Error loading safeguards.</p>');
                console.error('loadSafeguardsForProject: AJAX error for project:', project, { status: status, error: error, xhr: xhr });
            }
        });
    }

    // Function to load safeguards for a project without triggering change events
    function loadSafeguardsForProjectSilently(project, evidenceId, $tableContainer) {
        console.log('loadSafeguardsForProjectSilently: Started for project:', project, 'evidenceId:', evidenceId);
        
        // Clean up any existing DataTables in this container first
        $tableContainer.find('table.safeguards-table-accordion').each(function() {
            if ($.fn.DataTable.isDataTable(this)) {
                $(this).DataTable().destroy();
            }
        });
        
        $tableContainer.html('<div class="loader-sm"></div>'); // Show a loader
        
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'get_project_safeguards',
                projects: [project],
                evidence_id: evidenceId,
                nonce: evidenceData.nonce
            },
            success: function(safeguardsResponse) {
                console.log('loadSafeguardsForProjectSilently: AJAX success for project:', project, 'Response:', safeguardsResponse);
                if (safeguardsResponse.success && safeguardsResponse.data) {
                    const safeguards = safeguardsResponse.data;
                    console.log('loadSafeguardsForProjectSilently: Safeguards data:', safeguards);

                    if (safeguards.length === 0) {
                        $tableContainer.html('<p class="text-muted">No safeguards found for this project.</p>');
                        console.log('loadSafeguardsForProjectSilently: No safeguards returned for project:', project);
                        return;
                    }
                    
                    const tableId = 'safeguards-table-silent-' + project.replace(/[^a-zA-Z0-9]/g, '_') + '-' + new Date().getTime();
                    const table = $(`<table id="${tableId}" class="table table-bordered table-sm safeguards-table-accordion" style="width:100%"><thead><tr><th class="safeguard-select-header" style="width: 10%; text-align: center;">Select</th><th class="safeguard-id-header" style="width: 15%; text-align: center;">ID</th><th class="safeguard-description-header">Description</th></tr></thead><tbody></tbody></table>`);
                    const tbody = table.find('tbody');

                    safeguards.forEach(function(safeguard) {
                        const row = $('<tr></tr>');
                        const checkboxCell = $('<td class="text-center safeguard-select"><input type="checkbox" class="safeguard-checkbox"></td>');
                        checkboxCell.find('.safeguard-checkbox').prop('checked', safeguard.selected).data('safeguard-id', safeguard.id);
                        row.append(checkboxCell);
                        row.append(`<td class="safeguard-id">${safeguard.id}</td>`);
                        row.append(`<td class="safeguard-description">${safeguard.description}</td>`);
                        tbody.append(row);
                    });

                    $tableContainer.empty().append(table);
                    const dataTable = $('#' + tableId).DataTable({
                        "lengthChange": false,
                        "pageLength": 5,
                        "dom": "f" +
                               "<'row'<'col-sm-12'tr>>" +
                               "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
                        "order": [[1, "asc"]], // Sort by safeguard ID column (index 1) ascending
                        "columnDefs": [
                            { "orderable": false, "targets": 0 }, // Disable sorting on checkbox column
                            { 
                                "targets": 1,
                                "type": "string",
                                "render": function(data, type, row) {
                                    if (type === 'sort') {
                                        // Pad numbers for proper alphanumeric sorting
                                        return data.replace(/(\d+)/g, function(match) {
                                            return match.padStart(10, '0');
                                        });
                                    }
                                    return data;
                                }
                            }
                        ],
                        "language": {
                            "search": "",
                            "paginate": {
                                "previous": "‹",
                                "next": "›"
                            }
                        },
                        "initComplete": function() {
                            const searchInput = $(`#${tableId}_filter input`);
                            const searchWrapper = $(`#${tableId}_filter`);
                            
                            // Only look for search container within the same accordion (for existing project accordions)
                            const $accordionBody = $tableContainer.closest('.accordion-body');
                            let searchContainer = null;
                            
                            if ($accordionBody.length > 0) {
                                // This is an existing project accordion - find its specific search container
                                searchContainer = $accordionBody.find('.safeguard-search-container');
                            }

                            if (searchContainer && searchContainer.length > 0) {
                                // Clear any existing search inputs in this specific container first
                                searchContainer.find('input[type="search"]').remove();
                                
                                searchInput.attr('placeholder', 'Search safeguards...');
                                searchInput.unwrap(); // Remove the label
                                searchContainer.append(searchInput);
                                searchWrapper.remove(); // Remove the empty div
                            } else {
                                console.warn('Search container not found for table:', tableId);
                                // Keep the search in its default location if container not found
                            }
                        }
                    });
                    console.log('loadSafeguardsForProjectSilently: Table populated and initialized for project:', project);
                } else {
                    $tableContainer.html('<p class="text-danger">Error loading safeguards.</p>');
                    console.error('loadSafeguardsForProjectSilently: AJAX call not successful. Response:', safeguardsResponse);
                }
            },
            error: function(xhr, status, error) {
                $tableContainer.html('<p class="text-danger">Error loading safeguards.</p>');
                console.error('loadSafeguardsForProjectSilently: AJAX error for project:', project, { status: status, error: error, xhr: xhr });
            }
        });
    }

    // Handle safeguard selection change via checkbox
    $(document).on('change', '.safeguard-checkbox', function() {
        if (window.isLoadingExistingAssociations) return;

        const $checkbox = $(this);
        const safeguardId = $checkbox.data('safeguard-id');
        const isChecked = $checkbox.is(':checked');
        
        // Check if this is in a modal context (safeguards-table-modal)
        const $modalTable = $checkbox.closest('.safeguards-table-modal');
        if ($modalTable.length > 0) {
            // This is in the modal - handle modal-specific logic
            console.log(`Modal safeguard checkbox changed: ${safeguardId} -> ${isChecked}`);
            
            // Update global tracking for modal selections
            // console.log(`📝 CHECKBOX CHANGE DEBUG for ${safeguardId}: isChecked=${isChecked}`);
            // console.log(`📝 BEFORE UPDATE - Global selections:`, window.modalSafeguardSelections);
            
            if (isChecked) {
                // Add to global selections if not already present
                if (!window.modalSafeguardSelections.includes(safeguardId)) {
                    window.modalSafeguardSelections.push(safeguardId);
                    // console.log(`✅ Added safeguard ${safeguardId} to global selections`);
                } else {
                    // console.log(`ℹ️ Safeguard ${safeguardId} already in global selections`);
                }
            } else {
                // Remove from global selections
                const index = window.modalSafeguardSelections.indexOf(safeguardId);
                if (index > -1) {
                    window.modalSafeguardSelections.splice(index, 1);
                    // console.log(`❌ Removed safeguard ${safeguardId} from global selections`);
                } else {
                    // console.log(`ℹ️ Safeguard ${safeguardId} not in global selections`);
                }
                
                // Clear user assignments for this safeguard
                if (window.modalUserAssignments[safeguardId]) {
                    delete window.modalUserAssignments[safeguardId];
                    // console.log(`🗑️ Cleared user assignments for safeguard ${safeguardId}`);
                }
            }
            
            // console.log(`📝 AFTER UPDATE - Global selections:`, window.modalSafeguardSelections);
            
            // If safeguard is unchecked, clear the user assignments for this safeguard
            if (!isChecked) {
                const $userSelect = $modalTable.find(`.user-assignment-select[data-safeguard-id="${safeguardId}"]`);
                if ($userSelect.length > 0) {
                    console.log(`Clearing user assignments for unchecked safeguard ${safeguardId}`);
                    $userSelect.val(null).trigger('change');
                }
            }
            
            // Don't proceed with the regular update logic for modal checkboxes
            return;
        }
        
        // Regular non-modal logic (existing code)
        // Find the container - could be a card or accordion item
        const $container = $checkbox.closest('.card, .accordion-item');
        
        let project;
        if ($container.hasClass('card')) {
            // Traditional card structure
            project = $container.find('.project-selector').val();
        } else if ($container.hasClass('accordion-item')) {
            // New accordion structure - extract project from button data
            const projectSlug = $container.find('.remove-existing-project').data('project-slug');
            project = projectSlug;
        }
        
        const evidenceId = getPostIdFromBodyClass();

        // Get all selected safeguards for this project
        const selectedSafeguards = [];
        $container.find('.safeguard-checkbox:checked').each(function() {
            selectedSafeguards.push($(this).data('safeguard-id'));
        });

        if (project) {
            // Use the global function if available, otherwise call locally
            if (typeof window.updateProjectSafeguards === 'function') {
                window.updateProjectSafeguards(evidenceId, project, selectedSafeguards);
            } else {
                updateProjectSafeguards(evidenceId, project, selectedSafeguards);
            }
        }
    });

    // Local update function for safeguards
    function updateProjectSafeguards(evidenceId, project, safeguards) {
        console.log('Updating safeguards for project:', project, 'with:', safeguards);
        
        // Make sure safeguards is an array
        if (!Array.isArray(safeguards)) {
            safeguards = [];
        }
        
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'update_evidence_safeguards',
                evidence_id: evidenceId,
                project: project,
                safeguards: safeguards,
                nonce: evidenceData.nonce
            },
            success: function(response) {
                if (response.success) {
                    console.log('Safeguards updated successfully for project:', project);
                    // Refresh the display table if the global function is available
                    if (typeof window.loadProjectAssociationsDisplay === 'function') {
                        window.loadProjectAssociationsDisplay();
                    }
                } else {
                    console.error('Error updating safeguards:', response.data);
                    alert('Error updating safeguards. Please try again.');
                }
            },
            error: function(xhr, status, error) {
                console.error('AJAX error:', {
                    status: status,
                    error: error,
                    response: xhr.responseText
                });
                alert('Error updating safeguards. Please try again.');
            }
        });
    }

    // Function specifically designed for modal safeguard loading
    function loadSafeguardsForModal(project, evidenceId, $tableContainer, $searchContainer) {
        console.log('=== loadSafeguardsForModal DEBUG START ===');
        console.log('Project hash/slug:', project);
        console.log('Evidence ID:', evidenceId);
        console.log('Table container:', $tableContainer);
        console.log('Search container:', $searchContainer);
        console.log('Evidence Data:', evidenceData);
        
        // Clean up any existing DataTables in this container first
        $tableContainer.find('table').each(function() {
            if ($.fn.DataTable.isDataTable(this)) {
                console.log('Destroying existing DataTable');
                $(this).DataTable().destroy();
            }
        });
        
        // Remove existing tables and alerts, but preserve the loading animation
        $tableContainer.find('table, .alert').remove();
        
        // Hide search container initially
        if ($searchContainer && $searchContainer.length > 0) {
            $searchContainer.addClass('d-none');
        }
        
        // Show loading animation
        const $loadingElement = $tableContainer.find('.safeguard-loading');
        console.log('loadSafeguardsForModal: Loading element found:', $loadingElement.length);
        console.log('loadSafeguardsForModal: Loading element classes before:', $loadingElement.attr('class'));
        
        $loadingElement.removeClass('d-none');
        console.log('loadSafeguardsForModal: Loading element classes after removing d-none:', $loadingElement.attr('class'));
        console.log('Making AJAX request to:', evidenceData.ajax_url);
        
        const requestData = {
            action: 'get_project_safeguards',
            projects: [project],
            evidence_id: evidenceId,
            nonce: evidenceData.nonce
        };
        console.log('Request data:', requestData);
        
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: requestData,
            success: function(safeguardsResponse) {
                console.log('=== AJAX SUCCESS ===');
                console.log('Raw response:', safeguardsResponse);
                console.log('Response type:', typeof safeguardsResponse);
                console.log('Response success:', safeguardsResponse.success);
                console.log('Response data:', safeguardsResponse.data);
                console.log('Response data length:', safeguardsResponse.data ? safeguardsResponse.data.length : 'undefined');
                
                if (safeguardsResponse.success && safeguardsResponse.data) {
                    const safeguards = safeguardsResponse.data;
                    console.log('Safeguards array:', safeguards);

                    if (safeguards.length === 0) {
                        console.log('❌ EMPTY RESULT: No safeguards returned for project:', project);
                        console.log('This suggests either:');
                        console.log('1. Project not found in database');
                        console.log('2. Project has no framework assigned');
                        console.log('3. Framework not found in quality.json');
                        console.log('4. No matching safeguards for this framework');
                        // Hide loading animation and show warning
                        $tableContainer.find('.safeguard-loading').addClass('d-none');
                        const warningDiv = $('<div class="alert alert-warning"><strong>Debug Info:</strong> No safeguards found for this project. Check browser console and PHP error logs for details.</div>');
                        $tableContainer.append(warningDiv);
                        
                        // Keep search container hidden since there are no safeguards
                        if ($searchContainer && $searchContainer.length > 0) {
                            $searchContainer.addClass('d-none');
                        }
                        return;
                    }

                    const tableId = 'safeguards-table-modal-' + project.replace(/[^a-zA-Z0-9]/g, '_') + '-' + new Date().getTime();
                    const table = $(`<table id="${tableId}" class="table table-bordered table-sm safeguards-table-modal" style="width:100%"><thead><tr><th class="safeguard-select-header" style="width: 10%; text-align: center;">Select</th><th class="safeguard-id-header" style="width: 20%; text-align: center;">ID</th><th class="safeguard-description-header" style="width: 40%;">Description</th><th class="safeguard-users-header" style="width: 30%; text-align: center;">Assign to User(s)</th></tr></thead><tbody></tbody></table>`);
                    const tbody = table.find('tbody');

                    safeguards.forEach(function(safeguard) {
                        const row = $('<tr></tr>');
                        const checkboxCell = $('<td class="text-center safeguard-select"><input type="checkbox" class="safeguard-checkbox"></td>');
                        const checkbox = checkboxCell.find('.safeguard-checkbox');
                        
                        // Check global tracking to determine if this safeguard should be selected
                        const isGloballySelected = window.modalSafeguardSelections && window.modalSafeguardSelections.includes(safeguard.id);
                        const shouldBeChecked = safeguard.selected || isGloballySelected;
                        
                        // DEBUG: Log checkbox state determination
                        // console.log(`🔍 CHECKBOX DEBUG for safeguard ${safeguard.id}:`);
                        // console.log(`  - safeguard.selected: ${safeguard.selected}`);
                        // console.log(`  - isGloballySelected: ${isGloballySelected}`);
                        // console.log(`  - shouldBeChecked: ${shouldBeChecked}`);
                        // console.log(`  - Global selections:`, window.modalSafeguardSelections);
                        
                        // Set checkbox state and track initial selection for edit mode
                        checkbox.prop('checked', shouldBeChecked)
                               .data('safeguard-id', safeguard.id)
                               .data('initially-selected', shouldBeChecked);
                        
                        // Create user assignment select
                        const userSelectCell = $('<td class="text-center safeguard-users"></td>');
                        const userSelect = $('<select class="form-select form-select-sm user-assignment-select" multiple data-safeguard-id="' + safeguard.id + '"></select>');
                        userSelectCell.append(userSelect);
                        
                        row.append(checkboxCell);
                        row.append(`<td class="safeguard-id">${safeguard.id}</td>`);
                        row.append(`<td class="safeguard-description">${safeguard.description}</td>`);
                        row.append(userSelectCell);
                        tbody.append(row);
                    });

                    // Create a container div to hold the entire DataTable (including search and pagination)
                    const tableContainer = $('<div class="safeguards-table-container" style="display: none;"></div>');
                    tableContainer.append(table);
                    
                    // Don't hide loading animation yet - wait for Select2 to be ready
                    // $tableContainer.find('.safeguard-loading').addClass('d-none');
                    $tableContainer.append(tableContainer);
                    
                    // Don't show search container yet - wait for everything to be loaded
                    // if ($searchContainer && $searchContainer.length > 0) {
                    //     $searchContainer.removeClass('d-none');
                    // }
                    const dataTable = $('#' + tableId).DataTable({
                        "lengthChange": false,
                        "pageLength": 10,
                        "dom": "f" +
                               "<'row'<'col-sm-12'tr>>" +
                               "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
                        "order": [[1, "asc"]], // Sort by safeguard ID column (index 1) ascending
                        "columnDefs": [
                            { 
                                "orderable": false, 
                                "targets": 0,
                                "className": "safeguard-select-col"
                            }, // Disable sorting on checkbox column
                            { 
                                "targets": 1,
                                "type": "string",
                                "className": "safeguard-id-col",
                                "render": function(data, type, row) {
                                    if (type === 'sort') {
                                        // Pad numbers for proper alphanumeric sorting
                                        return data.replace(/(\d+)/g, function(match) {
                                            return match.padStart(10, '0');
                                        });
                                    }
                                    return data;
                                }
                            },
                            {
                                "targets": 2,
                                "className": "safeguard-description-col"
                            },
                            { 
                                "orderable": false, 
                                "targets": 3,
                                "className": "safeguard-users-col"
                            } // Disable sorting on user assignment column
                        ],
                        "language": {
                            "paginate": {
                                "previous": "‹",
                                "next": "›"
                            }
                        },
                        "initComplete": function() {
                            const searchInput = $(`#${tableId}_filter input`);
                            const searchWrapper = $(`#${tableId}_filter`);
                            
                            // Only move search if search container is provided
                            if ($searchContainer && $searchContainer.length > 0) {
                                // Clear any existing search inputs in the modal search container
                                $searchContainer.find('input[type="search"]').remove();
                                
                                searchInput.attr('placeholder', 'Search safeguards...');
                                searchInput.removeClass('form-control-sm').addClass('form-control');
                                searchInput.unwrap(); // Remove the label
                                $searchContainer.append(searchInput);
                                searchWrapper.remove(); // Remove the empty div
                            }
                        },
                        "drawCallback": function() {
                            // console.log(`🔄 DATATABLE DRAWCALLBACK TRIGGERED for table: ${tableId}`);
                            // console.log(`🔄 Current global selections:`, window.modalSafeguardSelections);
                            // console.log(`🔄 Current global user assignments:`, window.modalUserAssignments);
                            
                            // Check checkbox states on current page
                            const currentPageCheckboxes = $(`#${tableId} .safeguard-checkbox`);
                            // console.log(`🔄 Found ${currentPageCheckboxes.length} checkboxes on current page`);
                            
                            currentPageCheckboxes.each(function() {
                                const $checkbox = $(this);
                                const safeguardId = $checkbox.data('safeguard-id');
                                const isChecked = $checkbox.is(':checked');
                                const isGloballySelected = window.modalSafeguardSelections && window.modalSafeguardSelections.includes(safeguardId);
                                
                                // console.log(`🔄 Page checkbox ${safeguardId}: checked=${isChecked}, globallySelected=${isGloballySelected}`);
                                
                                // If globally selected but not checked, fix it
                                if (isGloballySelected && !isChecked) {
                                    // console.log(`🔧 FIXING: Setting checkbox ${safeguardId} to checked`);
                                    $checkbox.prop('checked', true);
                                }
                            });
                            
                            // Check user assignment dropdowns on current page
                            const currentPageSelects = $(`#${tableId} .user-assignment-select`);
                            // console.log(`🔄 Found ${currentPageSelects.length} user assignment selects on current page`);
                            
                            currentPageSelects.each(function() {
                                const $select = $(this);
                                const safeguardId = $select.data('safeguard-id');
                                const currentValue = $select.val();
                                const globalUserAssignments = window.modalUserAssignments && window.modalUserAssignments[safeguardId];
                                
                                // console.log(`🔄 Page select ${safeguardId}: currentValue=${currentValue}, globalAssignments=${globalUserAssignments}`);
                                
                                // If global assignments exist but select is empty, fix it
                                if (globalUserAssignments && globalUserAssignments.length > 0 && (!currentValue || currentValue.length === 0)) {
                                    // console.log(`🔧 FIXING: Setting user assignments for ${safeguardId} to:`, globalUserAssignments);
                                    $select.val(globalUserAssignments).trigger('change');
                                }
                            });
                            
                            // Initialize Select2 for any newly visible user assignment selects
                            // Only initialize if corporate users data is available
                            if (window.corporateUsersData && window.corporateUsersData[tableId]) {
                                // console.log('drawCallback: Corporate users data available, initializing Select2');
                                // Note: existingAssignments will be empty array for drawCallback since we don't have access to it here
                                // The function will still initialize Select2, but won't pre-populate with existing assignments
                                initializeSelect2ForVisibleRows(tableId, []);
                            } else {
                                // console.log('drawCallback: Corporate users data not available yet, skipping Select2 initialization');
                            }
                        }
                    });
                    console.log('loadSafeguardsForModal: Table populated and initialized for project:', project);
                    
                    // First get existing assignments for this project to determine which safeguards are selected
                    getExistingAssignmentsForProject(project, evidenceId, function(existingAssignments) {
                        console.log('Existing assignments for safeguard selection:', existingAssignments);
                        
                        // Create a set of safeguard IDs that have existing assignments
                        const assignedSafeguardIds = new Set();
                        existingAssignments.forEach(assignment => {
                            assignedSafeguardIds.add(assignment.safeguardID);
                        });
                        
                        // Update checkbox states based on existing assignments
                        // console.log(`📊 LOADING EXISTING ASSIGNMENTS - Before processing:`);
                        // console.log(`📊 Global selections:`, window.modalSafeguardSelections);
                        // console.log(`📊 Assigned safeguard IDs:`, Array.from(assignedSafeguardIds));
                        
                        safeguards.forEach(safeguard => {
                            const isSelected = assignedSafeguardIds.has(safeguard.id);
                            safeguard.selected = isSelected;
                            if (isSelected) {
                                // console.log(`📊 Safeguard ${safeguard.id} selected: ${isSelected}`);
                                // Add to global tracking
                                if (!window.modalSafeguardSelections.includes(safeguard.id)) {
                                    window.modalSafeguardSelections.push(safeguard.id);
                                    // console.log(`✅ Added safeguard ${safeguard.id} to global selections from existing assignments`);
                                } else {
                                    // console.log(`ℹ️ Safeguard ${safeguard.id} already in global selections`);
                                }
                            }
                        });
                        
                        // console.log(`📊 AFTER PROCESSING - Global selections:`, window.modalSafeguardSelections);
                        
                        // Also populate global user assignments from existing assignments
                        // console.log(`🌐 POPULATING GLOBAL USER ASSIGNMENTS FROM EXISTING ASSIGNMENTS`);
                        existingAssignments.forEach(assignment => {
                            const safeguardId = assignment.safeguardID;
                            const assignedTo = assignment.assignedTo;
                            
                            if (assignedTo) {
                                if (!window.modalUserAssignments[safeguardId]) {
                                    window.modalUserAssignments[safeguardId] = [];
                                }
                                if (!window.modalUserAssignments[safeguardId].includes(assignedTo)) {
                                    window.modalUserAssignments[safeguardId].push(assignedTo);
                                    // console.log(`🌐 Added user ${assignedTo} to global assignments for safeguard ${safeguardId}`);
                                }
                            }
                        });
                        // console.log(`🌐 Final global user assignments:`, window.modalUserAssignments);
                        
                        // Now update the checkboxes in the table with the correct global state
                        // console.log(`🔧 UPDATING CHECKBOXES WITH GLOBAL STATE`);
                        $(`#${tableId} .safeguard-checkbox`).each(function() {
                            const $checkbox = $(this);
                            const safeguardId = $checkbox.data('safeguard-id');
                            const isGloballySelected = window.modalSafeguardSelections && window.modalSafeguardSelections.includes(safeguardId);
                            
                            // console.log(`🔧 Updating checkbox ${safeguardId}: isGloballySelected=${isGloballySelected}`);
                            
                            if (isGloballySelected) {
                                $checkbox.prop('checked', true).data('initially-selected', true);
                                // console.log(`🔧 Set checkbox ${safeguardId} to checked`);
                            }
                        });
                        
                        
                        // Load corporate users and initialize select2 dropdowns with existing assignments
                        // Pass a callback to hide loading animation when everything is complete
                        // console.log(`🔍 PASSING EXISTING ASSIGNMENTS TO loadCorporateUsersForModal:`, existingAssignments);
                        loadCorporateUsersForModal(tableId, existingAssignments, function() {
                            // Now hide the loading animation and show the table after everything is loaded
                            $tableContainer.find('.safeguard-loading').addClass('d-none');
                            $tableContainer.find('.safeguards-table-container').show(); // Show the table container
                            
                            // Show search container now that everything is loaded
                            if ($searchContainer && $searchContainer.length > 0) {
                                $searchContainer.removeClass('d-none');
                            }
                            
                            console.log('loadSafeguardsForModal: All components loaded, loading animation hidden, table shown');
                        });
                    });
                } else {
                    console.log('❌ AJAX FAILURE: Response not successful');
                    console.log('Response:', safeguardsResponse);
                    // Hide loading animation and show error
                    $tableContainer.find('.safeguard-loading').addClass('d-none');
                    const errorDiv = $('<div class="alert alert-danger"><strong>Error:</strong> ' + (safeguardsResponse.data || 'Unknown error occurred') + '</div>');
                    $tableContainer.append(errorDiv);
                    
                    // Keep search container hidden since there was an error
                    if ($searchContainer && $searchContainer.length > 0) {
                        $searchContainer.addClass('d-none');
                    }
                }
            },
            error: function(xhr, status, error) {
                console.log('=== AJAX ERROR ===');
                console.log('Status:', status);
                console.log('Error:', error);
                console.log('XHR:', xhr);
                console.log('Response Text:', xhr.responseText);
                console.log('Status Code:', xhr.status);
                
                // Hide loading animation and show error
                $tableContainer.find('.safeguard-loading').addClass('d-none');
                const errorDiv = $('<div class="alert alert-danger"><strong>AJAX Error:</strong> ' + error + ' (Status: ' + status + ')</div>');
                $tableContainer.append(errorDiv);
                
                // Keep search container hidden since there was an error
                if ($searchContainer && $searchContainer.length > 0) {
                    $searchContainer.addClass('d-none');
                }
            }
        });
    }

    // Make functions available globally
    window.loadSafeguardsForProject = loadSafeguardsForProject;
    window.loadSafeguardsForProjectSilently = loadSafeguardsForProjectSilently;
    window.loadSafeguardsForModal = loadSafeguardsForModal;

    // Function to load corporate users and initialize select2 dropdowns for user assignment
    function loadCorporateUsersForModal(tableId, existingAssignments = [], callback) {
        // console.log('🔍 loadCorporateUsersForModal called with:');
        // console.log('🔍 Table ID:', tableId);
        // console.log('🔍 Existing assignments:', existingAssignments);
        // console.log('🔍 Existing assignments length:', existingAssignments.length);
        
        // Get current user ID from available data sources
        const currentUserId = window.controlsData?.current_user_id || window.evidenceData?.current_user_id;
        
        if (!currentUserId) {
            console.error('No current user ID found');
            callback(); // Call the callback even if no users are loaded
            return;
        }
        
        // Get AJAX URL from available data sources
        const ajaxUrl = window.controlsData?.ajax_url || window.evidenceData?.ajax_url;
        
        if (!ajaxUrl) {
            console.error('No AJAX URL found');
            callback(); // Call the callback even if no users are loaded
            return;
        }
        
        // Get nonce using the safeguardAssignment module's helper function
        const nonce = window.safeguardAssignment?.getNonceForAction('get_assignment_users') || 
                     window.evidenceData?.projectData_nonce || 
                     window.controlsData?.nonce || 
                     window.evidenceData?.nonce;
        
        console.log('Nonce sources available:');
        console.log('- safeguardAssignment:', !!window.safeguardAssignment);
        console.log('- controlsData.nonce:', !!window.controlsData?.nonce);
        console.log('- evidenceData.nonce:', !!window.evidenceData?.nonce);
        console.log('- Final nonce:', !!nonce);
        
        if (!nonce) {
            console.error('No nonce found for get_assignment_users action');
            callback(); // Call the callback even if no users are loaded
            return;
        }
        
        // Get evidence ID from the current context
        const evidencePostId = getPostIdFromBodyClass();
        console.log('loadCorporateUsersForModal: Evidence Post ID:', evidencePostId);
        console.log('loadCorporateUsersForModal: Current User ID:', currentUserId);
        
        // First get the actual evidence slug from the post ID
        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'safeguard_assignment',
                subaction: 'get_evidence_id_from_post',
                post_id: evidencePostId,
                nonce: window.evidenceData?.safeguard_assignment_nonce || nonce
            },
            success: function(evidenceResponse) {
                console.log('get_evidence_id_from_post response:', evidenceResponse);
                if (evidenceResponse.success && evidenceResponse.data) {
                    const evidenceSlug = evidenceResponse.data;
                    console.log('loadCorporateUsersForModal: Evidence slug:', evidenceSlug);
                    
                    // Now get the assignment users with the correct evidence slug
                    $.ajax({
                        url: ajaxUrl,
                        type: 'POST',
                        data: {
                            action: 'get_assignment_users',
                            user_id: currentUserId,
                            evidence_id: evidenceSlug,
                            nonce: nonce
                        },
                        success: function(response) {
                            if (response.success && response.data) {
                                console.log('Assignment users loaded:', response.data);
                                
                                // Store the corporate users data globally for this table
                                window.corporateUsersData = window.corporateUsersData || {};
                                window.corporateUsersData[tableId] = response.data;
                                
                                // Initialize select2 dropdowns for visible rows
                                initializeSelect2ForVisibleRows(tableId, existingAssignments);
                                
                                console.log('Select2 dropdowns initialized for user assignment');
                                callback(); // Call the callback after all dropdowns are initialized
                            } else {
                                console.error('Failed to load assignment users:', response);
                                callback(); // Call the callback even if users fail to load
                            }
                        },
                        error: function(xhr, status, error) {
                            console.error('AJAX error loading assignment users:', error);
                            callback(); // Call the callback even if users fail to load
                        }
                    });
                } else {
                    console.error('Failed to get evidence slug from post ID:', evidenceResponse);
                    callback(); // Call the callback even if evidence slug fails
                }
            },
            error: function(xhr, status, error) {
                console.error('AJAX error getting evidence slug:', error);
                callback(); // Call the callback even if evidence slug fails
            }
        });
    }

    // Function to initialize Select2 for visible rows in a DataTable
    function initializeSelect2ForVisibleRows(tableId, existingAssignments = []) {
        // console.log(`🔍 initializeSelect2ForVisibleRows called with:`);
        // console.log(`🔍 Table ID: ${tableId}`);
        // console.log(`🔍 Existing assignments:`, existingAssignments);
        // console.log(`🔍 Existing assignments length:`, existingAssignments.length);
        
        // Get corporate users data for this table
        const corporateUsers = window.corporateUsersData?.[tableId];
        if (!corporateUsers) {
            // console.warn(`No corporate users data found for table ${tableId}`);
            // If corporate users data is not available, try again after a short delay
            setTimeout(() => {
                // console.log(`Retrying Select2 initialization for table ${tableId} after delay`);
                initializeSelect2ForVisibleRows(tableId, existingAssignments);
            }, 100);
            return;
        }
        
        // Find all user assignment selects in visible rows that don't have Select2 initialized
        $(`#${tableId} .user-assignment-select:not(.select2-hidden-accessible)`).each(function() {
            const $select = $(this);
            const safeguardId = $select.data('safeguard-id');
            
            console.log(`Initializing Select2 for safeguard ${safeguardId} in table ${tableId}`);
            
            // Clear any existing options first
            $select.empty();
            
            // Initialize select2 with placeholder
            $select.select2({
                placeholder: 'Assign To User(s)',
                allowClear: true,
                width: '100%',
                dropdownParent: $select.closest('.modal-body')
            }).on('select2:select select2:unselect', function(e) {
                // Handle both selection and deselection events
                const selectedUsers = $(this).val();
                console.log(`Select2 event triggered for safeguard ${safeguardId}:`, e.type, 'selectedUsers:', selectedUsers);
                
                // Update the data attribute
                $(this).data('selected-users', selectedUsers);
                
                // Update global tracking for user assignments
                if (selectedUsers && selectedUsers.length > 0) {
                    window.modalUserAssignments[safeguardId] = selectedUsers;
                    // console.log(`🌐 Updated global user assignments for safeguard ${safeguardId}:`, selectedUsers);
                    // console.log(`🌐 Current global user assignments:`, window.modalUserAssignments);
                } else {
                    // Clear user assignments if none selected
                    if (window.modalUserAssignments[safeguardId]) {
                        delete window.modalUserAssignments[safeguardId];
                        // console.log(`🌐 Cleared global user assignments for safeguard ${safeguardId}`);
                        // console.log(`🌐 Current global user assignments:`, window.modalUserAssignments);
                    }
                }
                
                // Update placeholder display
                updatePlaceholder();
                
                // Automatically check/uncheck the safeguard checkbox
                setTimeout(() => {
                    // Find checkbox in the same row as the Select2
                    const $currentRow = $(this).closest('tr');
                    const $safeguardCheckbox = $currentRow.find('.safeguard-checkbox');
                    
                    if ($safeguardCheckbox.length > 0) {
                        const shouldBeChecked = selectedUsers && selectedUsers.length > 0;
                        const currentlyChecked = $safeguardCheckbox.is(':checked');
                        
                        if (shouldBeChecked !== currentlyChecked) {
                            console.log(`Select2 event - Auto-checking safeguard ${safeguardId}: ${shouldBeChecked}`);
                            $safeguardCheckbox.prop('checked', shouldBeChecked);
                            $safeguardCheckbox.trigger('change');
                        }
                    } else {
                        console.warn(`Select2 event - Safeguard checkbox not found in row for safeguard ${safeguardId}`);
                    }
                }, 50);
            });
            
            // Add options to the select after initialization
            corporateUsers.forEach(user => {
                const option = new Option(user.name, user.id, false, false);
                $select.append(option);
            });
            
            // Add a custom placeholder display when no users are selected
            function updatePlaceholder() {
                const selectedCount = $select.val() ? $select.val().length : 0;
                const $selection = $select.next('.select2').find('.select2-selection__rendered');
                
                if (selectedCount === 0) {
                    $selection.html('<span class="text-muted assignment-placeholder">Assign To User(s)</span>');
                }
            }
            
            // Initial placeholder check
            updatePlaceholder();
            
            // Update placeholder on change
            $select.on('change', function() {
                updatePlaceholder();
            });
            
            // Pre-populate with existing assignments for this safeguard
            if (existingAssignments.length > 0) {
                const safeguardAssignments = existingAssignments.filter(assignment =>
                    assignment.safeguardID === safeguardId
                );

                // console.log(`🔍 PRE-POPULATION DEBUG for safeguard ${safeguardId}:`);
                // console.log(`🔍 Found ${safeguardAssignments.length} assignments for this safeguard`);
                // console.log(`🔍 Assignments:`, safeguardAssignments);

                if (safeguardAssignments.length > 0) {
                    const assignedUserIds = safeguardAssignments.map(assignment => assignment.assignedTo);
                    // console.log(`🔍 Mapped user IDs:`, assignedUserIds);
                    // console.log(`Pre-populating safeguard ${safeguardId} with users:`, assignedUserIds);
                    $select.val(assignedUserIds).trigger('change');

                    // Update global tracking with pre-populated assignments
                    if (assignedUserIds.length > 0) {
                        window.modalUserAssignments[safeguardId] = assignedUserIds;
                        // console.log(`🌐 Updated global user assignments for safeguard ${safeguardId} from existing assignments:`, assignedUserIds);
                        // console.log(`🌐 Current global user assignments:`, window.modalUserAssignments);
                    }
                } else {
                    // console.log(`🔍 No assignments found for safeguard ${safeguardId}`);
                }
            } else {
                // console.log(`🔍 No existing assignments provided for pre-population`);
            }
            
            // Also check global tracking for any user assignments made on other pages
            if (window.modalUserAssignments && window.modalUserAssignments[safeguardId]) {
                const globalUserAssignments = window.modalUserAssignments[safeguardId];
                // console.log(`🌐 Pre-populating safeguard ${safeguardId} with global user assignments:`, globalUserAssignments);
                $select.val(globalUserAssignments).trigger('change');
            } else {
                // console.log(`🌐 No global user assignments found for safeguard ${safeguardId}`);
            }
            
            // Handle user assignment changes
            $select.on('change', function() {
                const selectedUsers = $(this).val();
                // console.log(`User assignment changed for safeguard ${safeguardId}:`, selectedUsers);
                
                // Store the selected users in the select element's data
                $(this).data('selected-users', selectedUsers);
                
                // Update global tracking for user assignments
                if (selectedUsers && selectedUsers.length > 0) {
                    window.modalUserAssignments[safeguardId] = selectedUsers;
                    // console.log(`🌐 Updated global user assignments for safeguard ${safeguardId}:`, selectedUsers);
                    // console.log(`🌐 Current global user assignments:`, window.modalUserAssignments);
                } else {
                    // Clear user assignments if none selected
                    if (window.modalUserAssignments[safeguardId]) {
                        delete window.modalUserAssignments[safeguardId];
                        // console.log(`🌐 Cleared global user assignments for safeguard ${safeguardId}`);
                        // console.log(`🌐 Current global user assignments:`, window.modalUserAssignments);
                    }
                }
                
                // Update placeholder display
                updatePlaceholder();
                
                // Automatically check/uncheck the safeguard checkbox based on user selection
                setTimeout(() => {
                    // Find checkbox in the same row as the Select2
                    const $currentRow = $select.closest('tr');
                    const $safeguardCheckbox = $currentRow.find('.safeguard-checkbox');
                    
                    if ($safeguardCheckbox.length > 0) {
                        const shouldBeChecked = selectedUsers && selectedUsers.length > 0;
                        const currentlyChecked = $safeguardCheckbox.is(':checked');
                        
                        if (shouldBeChecked !== currentlyChecked) {
                            console.log(`Auto-checking safeguard ${safeguardId}: ${shouldBeChecked} (users selected: ${selectedUsers ? selectedUsers.length : 0})`);
                            $safeguardCheckbox.prop('checked', shouldBeChecked);
                            $safeguardCheckbox.trigger('change');
                        }
                    } else {
                        console.warn(`Safeguard checkbox not found in row for safeguard ${safeguardId}`);
                    }
                }, 100); // Small delay to ensure Select2 has finished processing
            });
        });
    }

    // Make the function available globally
    window.loadCorporateUsersForModal = loadCorporateUsersForModal;

    // Function to get existing assignments for a project
    function getExistingAssignmentsForProject(projectId, evidenceId, callback) {
        console.log('Getting existing assignments for project:', projectId, 'evidence:', evidenceId);
        
        // Get AJAX URL from available data sources
        const ajaxUrl = window.controlsData?.ajax_url || window.evidenceData?.ajax_url;
        
        if (!ajaxUrl) {
            console.error('No AJAX URL found');
            callback([]);
            return;
        }
        
        // Get nonce from available data sources
        const nonce = window.evidenceData?.safeguard_assignment_nonce || window.controlsData?.nonce || window.evidenceData?.nonce;
        
        if (!nonce) {
            console.error('No nonce found');
            callback([]);
            return;
        }
        
        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'safeguard_assignment',
                subaction: 'get_evidence_assignments',
                evidence_id: evidenceId,
                nonce: nonce
            },
            success: function(response) {
                if (response.success && response.data) {
                    // Filter assignments for this specific project
                    const projectAssignments = response.data.filter(assignment => 
                        assignment.projectID === projectId
                    );
                    console.log('Existing assignments for project:', projectAssignments);
                    callback(projectAssignments);
                } else {
                    console.error('Failed to get existing assignments:', response);
                    callback([]);
                }
            },
            error: function(xhr, status, error) {
                console.error('AJAX error getting existing assignments:', error);
                callback([]);
            }
        });
    }

    // Make the function available globally
    window.getExistingAssignmentsForProject = getExistingAssignmentsForProject;
    window.initializeSelect2ForVisibleRows = initializeSelect2ForVisibleRows;

});
